<template>
    <div class="mt-3" v-if="canEnable2FA">
        <b-button v-b-toggle="'config2fa'">{{$t('setup2FA')}}</b-button>
        <b-collapse id="config2fa">
            <b-card bg-variant="light" class="setup2FA">
                <b-container fluid>
                    <b-row>
                        <b-col cols="2">
                            <div class="qrcodeWrapper" @click="show2FAKey = !show2FAKey"
                                    @keydown.space="show2FAKey=!show2FAKey"
                                    tabindex="-1">
                                <qrcode :value="qrcodeValue" size="150" ></qrcode>
                            </div>
                            <b-button @click="doRegenerateTotpKey">{{$t('button.regenerateTotpKey')}}</b-button>

                        </b-col>
                        <b-col>
                            <b-container fluid>
                                <b-row class="mb-3">
                                    <b-col>
                                        <span v-show="adminRequire2FA">
                                        {{$t('adminMandated2FA')}}
                                        </span>
                                        <span v-show="userRequire2FA && !adminRequire2FA">
                                            {{$t('twoFactorAuthenticationEnabled')}}
                                        </span>
                                        <span v-show="!userRequire2FA && !adminRequire2FA">
                                            {{$t('twoFactorAuthenticationDisabled')}}
                                        </span>

                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-form-group :label="$t('verify2FALabel')">
                                            <b-input maxlength="6" v-model="totpVerification"
                                                    @input="totpVerificationResult=null"
                                                    :placeholder="$t('verify2FAPlaceholder')">
                                            </b-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-3">
                                    <b-col>
                                        <b-button :disabled="totpVerification.length!=6"
                                                @click="do2FAVerify">{{verifyButtonText}}
                                        </b-button>
                                        <span v-if="this.totpVerificationResult === true" class="verificationSuccess">
                                {{$t(totpSecretSaved ? 'verify2FAAndSaveSuccess' : 'verify2FASuccess')}}
                            </span>
                                        <span v-if="this.totpVerificationResult === false" class="verificationFailure">
                                {{$t('verify2FAFailure')}}
                            </span>
                                    </b-col>
                                </b-row>
                                <b-row v-if="!adminRequire2FA">
                                    <b-col>
                                        <b-button v-show="!userRequire2FA"
                                                :disabled="this.totpVerificationResult !== true"
                                                @click="doEnable">
                                            {{$t('button.enable')}}
                                        </b-button>
                                        <b-button v-show="userRequire2FA"
                                                @click="doDisable">
                                            {{$t('button.disable')}}
                                        </b-button>
                                        <save-success-indicator v-model="saveSuccess"></save-success-indicator>
                                        <span class="error">{{saveError}}</span>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-col>
                    </b-row>
                    <b-row v-show="show2FAKey">
                        <b-col>
                            <div class="tfakey">
                                {{$t('totpSecret', { secret: totpSecret })}}
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
import Qrcode from 'qrcode.vue';
import axios from 'axios';
import SaveSuccessIndicator from '@/components/saveSuccessIndicator';
import trimEnd from 'lodash/trimEnd';

export default {
  name: 'twoFactorAuthentication',
  components: { Qrcode, SaveSuccessIndicator },
  i18nOptions: { keyPrefix: 'settings.passwords.twoFactorAuthentication' },
  data: function() {
    return {
      thisTotpSecret: '',
      show2FAKey: false,
      totpVerification: '',
      totpVerificationResult: null,
      totpNeedsVerifying: false,
      totpSecretSaved: false,
      saving: false,
      saveSuccess: false,
      saveError: ''
    };
  },
  methods: {
    doRegenerateTotpKey() {
      this.$dialog.confirm(this.$t('confirmRegenerateTotpKey'), {
        okText: this.$t('confirmRegenerateTotpKeyOK'),
        cancelText: this.$t('confirmRegenerateTotpKeyCancel')
      })
        .then(() => {
          this.$RPC('settings', 'getnewtotpkey')
            .then(d => {
              this.thisTotpSecret = d.newkey;
              this.totpVerificationResult = null;
              this.totpVerification = '';
            });
        });
    },
    do2FAVerify() {
      this.$RPC('settings', 'validatetotpkey', {
        secret: this.totpSecret,
        password: this.totpVerification,
        saveSecret: true
      })
        .then(d => {
          this.totpVerificationResult = d.validated;
          this.totpVerification = '';
          this.totpSecretSaved = d.saved && (!!this.thisTotpSecret);
          if (d.saved) {
            this.thisTotpSecret = '';
          }
        });
    },
    doEnable() {
      this.doSave(true);
    },
    doDisable() {
      this.doSave(false);
    },
    doSave(enable) {
      let settings = {
        userrequire2fa: enable
      };
      this.saving = true;
      this.saveSuccess = false;
      axios.patch('/rest/user/settings', settings)
        .then(d => {
          console.log(d);
          this.saveError = '';
          this.saveSuccess = true;
        })
        .catch(e => {
          this.saveError = this.$t('saveError', { error: e.message });
        })
        .finally(() => {
          this.saving = false;
        });
    }
  },
  computed: {
    canEnable2FA() {
      return true;
    },
    adminRequire2FA() {
      return this.$store.state.settings.require2fa;
    },
    userRequire2FA() {
      return this.$store.state.settings.userrequire2fa;
    },
    qrcodeValue() {
      return `otpauth://totp/VPOP3:${this.$store.state.username}?secret=${this.totpSecret}` +
        `&issuer=${this.$store.getters.totpServerName}\n`;
    },
    totpSecret() {
      return trimEnd(this.thisTotpSecret || this.$store.state.settings.totpkey, '=');
    },
    verifyButtonText() {
      if (this.thisTotpSecret) {
        return this.$t('button.verifyAndSave');
      } else {
        return this.$t('button.verify');
      }
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .setup2FA {
        margin-top: 0.5em;
        .qrcodeWrapper {
            width: 150px;
        }
        .verificationSuccess {
            color: $success;
        }
        .verificationFailure {
            color: $danger;
        }
    }

</style>
